import { AfterViewInit, Component, Inject } from '@angular/core';
import { Router } from "@angular/router";

import { CookieService } from 'ngx-cookie-service';

import { ContextService } from '../../../technical-modules/context/services/context.service';
import { EventBusService, Events } from '../../../technical-modules/events/services/event-bus.service';

import { UserService } from '../../../data-domains/humain/user/services/user.service';
import { UserTLR } from '../../../data-domains/humain/user/entities/user-tlr.entity';

@Component({
	selector: 'account-menu',
	templateUrl: 'account-menu.html',
	styleUrls: ['account-menu.css'],
})
export class AccountMenuComponent implements AfterViewInit {
	clientPath: string;
	user!: UserTLR;
	
	constructor(
        private router: Router,
		
		@Inject(CookieService) private cookieService: CookieService,

		@Inject(ContextService) private contextService: ContextService,
		@Inject(EventBusService) private eventBusService: EventBusService,

		@Inject(UserService) userService: UserService,
	) {
		this.clientPath = (window as any).clientPath;

		let user$ = userService.getCurrentUserTLR();
		user$.subscribe(
			(user) => this.user = user
		)
	}
	
	ngAfterViewInit() {
		// Evol 56736
		// Apres l'initalisation du menu utiliser, on regarde si un page
		// precise avait ete demandee par l'utilisateur a l'ouverture d'Aurora
		let requestedHash = this.contextService.getRequestedHash();
		if (requestedHash) {
			requestedHash = "/" + requestedHash;
			this.contextService.setRequestedHash(null);
			let currentHash = this.router.url;
			
			if (currentHash !== requestedHash) {
				this.router.navigate([requestedHash]);
			}
		}
		// NB: Ceci pourrait etre dans un composant a part, mais le menu "account"
		// etant charge dans tous les cas, il est ici pratique d'utilisation
		// => A deplacer si on commence a avoir plusieurs besoins de ce genre
	}

	openMesAlertes() {
		this.eventBusService.emit(Events.EditUserPreferencesNotificationsRequested, null);
	}

	logOut() {
		if (confirm('Merci de confirmer que vous souhaitez vous déconnecter, vous serez redirigé vers la page de connexion')) {
			this.cookieService.delete('JSESSIONID');
			this.cookieService.delete('OKTA_COOKIE');
			window.location.href = '/' + this.clientPath + 'api/users/logout';
		}
	}
}